// Pricing
import PricingServiceClient from "./src/clients/PricingService";
import { DefaultPricingServiceConfig } from "./src/config/PricingServiceConfig";
// MPV Service
import MerchandisingProductViewServiceClient from "./src/clients/MerchandisingProductViewService";
import { DefaultMerchandisingProductViewServiceConfig } from "./src/config/MerchandisingProductViewServiceConfig";
// Product Surface
import ProductSurfacesServiceClient from "./src/clients/ProductSurfaceService";
import { DefaultProductSurfaceServiceConfig } from "./src/config/ProductSurfaceServiceConfig";
// Design Service
import DesignServiceClient from "./src/clients/DesignService";
import { DefaultDesignServiceConfig } from "./src/config/DesignServiceConfig";
// Gallery
import GalleryUrlService from "./src/clients/GalleryUrlService";
// URL
import { UrlServiceClient } from "./src/clients/UrlService";
import { DefaultUrlServiceConfig } from "./src/config/UrlServiceConfig";
// Product Catalog
import ProductCatalogServiceClient from "./src/clients/ProductCatalogService";
import { DefaultProductCatalogConfig } from "./src/config/ProductCatalogServiceConfig";
// Live Site Service
import LiveSiteServiceClient from "./src/clients/LiveSiteService";
import { DefaultLiveSiteServiceConfig } from "./src/config/LiveSiteServiceConfig";
import OptimizelyServiceProxyClient from "./src/clients/OptimizelyProxyService";
import OptimizelyServiceClient from "./src/clients/OptimizelyService";
import { DefaultOptimizelyServiceConfig } from "./src/config/OptimizelyServiceConfig";
import OlapicService from "./src/clients/OlapicService";
import { DefaultOlapicServiceConfig } from "./src/config/OlapicServiceConfig";
import SiteTenantConfigServiceClient from "./src/clients/SiteTenantConfigService";
import { DefaultSiteTenantConfigServiceConfig } from "./src/config/SiteTenantConfigServiceConfig";
// Pasta
import PastaServiceClient from "./src/clients/PastaService";
import { DefaultPastaServiceConfig } from "./src/config/PastaConfig";
// Wrangler
import WranglerServiceClient from "./src/clients/WranglerService";
import { DefaultWranglerServiceConfig } from "./src/config/WranglerServiceConfig";
// MSX
import MsxServiceClient from "./src/clients/MsxService";
import { DefaultMsxServiceConfig } from "./src/config/MsxServiceConfig";
const Pricing = {
    serviceClient: PricingServiceClient,
    config: DefaultPricingServiceConfig
};
const Mpv = {
    serviceClient: MerchandisingProductViewServiceClient,
    config: DefaultMerchandisingProductViewServiceConfig
};
const Surfaces = {
    serviceClient: ProductSurfacesServiceClient,
    config: DefaultProductSurfaceServiceConfig
};
const DesignService = {
    serviceClient: DesignServiceClient,
    config: DefaultDesignServiceConfig
};
const Gallery = {
    service: GalleryUrlService
};
const Url = {
    service: UrlServiceClient,
    config: DefaultUrlServiceConfig
};
const ProductCatalog = {
    serviceClient: ProductCatalogServiceClient,
    config: DefaultProductCatalogConfig
};
const LiveSite = {
    serviceClient: LiveSiteServiceClient,
    config: DefaultLiveSiteServiceConfig
};
const Optimizely = {
    serviceClient: OptimizelyServiceClient,
    config: DefaultOptimizelyServiceConfig
};
const OptimizelyProxy = {
    serviceClient: OptimizelyServiceProxyClient
};
const Olapic = {
    serviceClient: OlapicService,
    config: DefaultOlapicServiceConfig
};
const SiteTenantConfig = {
    serviceClient: SiteTenantConfigServiceClient,
    config: DefaultSiteTenantConfigServiceConfig
};
const Pasta = {
    serviceClient: PastaServiceClient,
    config: DefaultPastaServiceConfig
};
const Wrangler = {
    serviceClient: WranglerServiceClient,
    config: DefaultWranglerServiceConfig
};
const Msx = {
    serviceClient: MsxServiceClient,
    config: DefaultMsxServiceConfig,
};
export { Pricing, Mpv, Surfaces, DesignService, Gallery, Url, ProductCatalog, Pasta, LiveSite, Optimizely, OptimizelyProxy, Olapic, SiteTenantConfig, Wrangler, Msx };
//# sourceMappingURL=index.js.map